var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['colour-picker-hue-strip', `direction-${_vm.direction}`]},[_c('div',{ref:"container",staticClass:"strip-container",on:{"mousedown":_vm.mouseDown,"touchmove":_vm.changeHue,"touchstart":_vm.changeHue}},[_c('div',{staticClass:"strip-pointer",style:({
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    })},[_c('div',{staticClass:"strip-picker",attrs:{"tabindex":"0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }